import { h } from './dom';

interface Step { k: string; t: string; d: string; }

const STEPS: Step[] = [
  { k: 'STEP 01', t: 'Brief', d: "30 minutes. We figure out if there's a damn good fit. No pitch deck." },
  { k: 'STEP 02', t: 'Scope', d: 'Fixed scope, fixed price, or T&M. Whichever shape fits the work.' },
  { k: 'STEP 03', t: 'Build', d: 'Weekly demos. You see the code. The repo is yours from day one.' },
  { k: 'STEP 04', t: 'Ship',  d: "We don't disappear at launch. Sixty days of post-ship support included." },
];

function Step(s: Step): HTMLElement {
  return h('li', { class: 's-process__step' },
    h('span', { class: 's-process__k' }, s.k),
    h('div', {},
      h('h3', { class: 's-process__t' }, s.t),
      h('p', { class: 's-process__d' }, s.d),
    ),
  );
}

export function Process(): HTMLElement {
  const caption = h('div', { class: 's-section__caption' });
  caption.append('// 04 STEPS', h('br'), 'BRIEF → SHIP');

  const title = h('h2', { class: 's-section__title' });
  title.append('Four steps. ', h('b', {}, 'No surprises.'));

  return h('section', { id: 'process', class: 's-section' },
    caption,
    h('header', { class: 's-section__head' },
      h('span', { class: 's-section__num' }, '03'),
      title,
    ),
    h('ol', { class: 's-process' }, ...STEPS.map(Step)),
  );
}
